import { Directive } from '@angular/core';

@Directive({ selector: '[ldSectionBody]' })
export class SectionBodyDirective {
}
